//#region src/constants/open.ts
var Open = {
	automaticTablePlacement: "automaticTablePlacement",
	tableProperties: "tableProperties",
	search: "search",
	themeBuilder: "themeBuilder",
	localePicker: "localePicker",
	diffViewer: "diffViewer",
	timeTravel: "timeTravel",
	exportImage: "exportImage",
	mapColumns: "mapColumns"
};
//#endregion
export { Open };
